import React, { useState, useEffect, useRef, useContext } from 'react'
import { ApiGetCall } from '../JS/Connector';
import { getTypeWatchDelay, LogInUserID, onKeyDownRestrict, onPasteRestriction } from '../JS/Common';
import { typewatch } from '../JS/Common';
import AlertPopup from './AlertPopup';
import { UserContext } from '../App';
import { useDispatch } from 'react-redux';
import { setAdminSchoolId, setDefaultTicketStatus, setSchoolContactID, setSchoolname, setSelectedSchoolTimeZone } from '../Store/Slices/authSlice';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../JS/RoleType';
import useConfig from '../Hooks/useConfig';
import { useNavigate } from 'react-router-dom';

export function Globalsearchbar() {
  const { organization } = useConfig();
  const navigate = useNavigate();
  const StateData = useSelector((state) => state.authData);
  const { UserData } = useContext(UserContext);
  const [SearchForSchoolName, setSearchForSchoolName] = useState("");
  const [SuggestionBoxArray, setSuggestionBoxArray] = useState([]);
  const [innerload, setinnerload] = useState(false);
  const [SchoolSuggestiobBox, setSchoolSuggestiobBox] = useState({
    ShowSuggestion: "d-none",
  });
  const [SchoolData, setSchoolData] = useState({
    Schoolname: '',
    SchoolID: '',
    schoolTimeZone: '',
    defaultTicketStatus: ''
  });
  const [WarningPopup, setWarningPopup] = useState(false);
  const [PendingSchoolSelection, setPendingSchoolSelection] = useState(null);
  const storedSchoolname = StateData?.Schoolname;
  const suggestionBoxRef = useRef(null);
  const reduxDispatch = useDispatch();
  useEffect(() => {
    const storedSearchValue = StateData?.AdminSchoolId;
    setSchoolData({ ...SchoolData, Schoolname: storedSchoolname, SchoolID: storedSearchValue, schoolTimeZone: StateData?.SelectedSchoolTimeZone, defaultTicketStatus: StateData?.DefaultTicketStatus })
    const handleClickOutside = (event) => {
      if (suggestionBoxRef.current && !suggestionBoxRef.current.contains(event.target)) {
        setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: "d-none" })
      }
    };
    const handleWindowClick = (event) => {
      handleClickOutside(event);
    };
    window.addEventListener('click', handleWindowClick);
    return () => {
      window.removeEventListener('click', handleWindowClick);
    };
  }, [])

  useEffect(() => {
    syncSchoolTimezone();
  }, []);

  async function syncSchoolTimezone() {
    if (StateData?.AdminSchoolId) {
      await ApiGetCall(`/schools/by-id?schoolId=${StateData.AdminSchoolId}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          if (responseRs?.timezone_data?.timezone) {
            reduxDispatch(setSelectedSchoolTimeZone(responseRs?.timezone_data?.timezone));
          }
        }
      });
    }
  }

  async function showSchoolName(searchString) {
    if (searchString?.trim() == "") {
      searchString = null;
    } else {
      searchString = searchString?.trim();
    }
    if (!searchString) return;
    setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: "" });
    setSuggestionBoxArray([])
    typewatch(async function () {
      setinnerload(true);
      await ApiGetCall(`/search-global?search=${searchString}&userId=${LogInUserID}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          var sugData = responseRs.msg;

          if (sugData.length !== 0) {
            const effectiveRole = UserData.copyrole || UserData.role || null;
            const shouldRestrict = hasRoleAccess(effectiveRole, RoleEnum.ONLY_TECH);

            const handleClick = (schoolData) => {
              const isSameLocation = schoolData.location_assign_flag == 1;

              if (shouldRestrict && !isSameLocation) {
                setPendingSchoolSelection(schoolData);
                setWarningPopup(true);
              } else {
                setSearchForSchoolName("");
                showSchoolData(schoolData);
                navigate("/school-tickets", {
                  state: {
                    search: schoolData?.ticket_num,
                    status: schoolData?.grid_status,
                  },
                });
              }
            };

            const sugArray = (
              <div className="row mx-0 brdr-Btm font-14">
                {sugData.map((school, i) => {
                  const isSameLocation = school.location_assign_flag == 1;

                  return (
                    <div
                      key={i}
                      className={`col-4 p-2 text-start ${isSameLocation ? "blueText" : ""}`}
                      id={school.id}
                      name={school.name}
                      olduserid={school.oldest_user_id}
                      schoolTimeZone={school?.timezone_data?.timezone}
                      defaultTicketStatus={school.default_ticket_status == 1 ? 1 : 0}
                      style={{ padding: "8px 15px", cursor: "pointer" }}
                      onClick={() => handleClick(school)}
                    >
                      <div className="globalSearchCard h-100 p-2">
                        <b className="truncate-field" style={{ '--truncate-width': '190px' }} title={school?.school_name}>{school.school_name}</b>
                        <br />
                        Serial #: <label className="truncate-field" style={{ '--truncate-width': '130px' }} title={school?.serial_num}>{school?.serial_num || "-"}</label>
                        <br />
                        Ticket #: <label className="truncate-field" style={{ '--truncate-width': '130px' }} title={school?.ticket_num}>{school?.ticket_num || "-"}</label>
                        <br />
                        Asset Tag: <label className="truncate-field" style={{ '--truncate-width': '130px' }} title={school?.asset_tag}>{school?.asset_tag || "-"}</label>
                        <br />
                        Ticket Status: <label className="truncate-field" style={{ '--truncate-width': '100px' }} title={school?.ticket_status}>{school?.ticket_status || "-"}</label>
                      </div>
                    </div>
                  );
                })}
              </div>
            );

            setSuggestionBoxArray(sugArray);
          } else {
            setSuggestionBoxArray([
              <div className="col-12 text-center" key="no-record">
                <label>No Record Found</label>
              </div>
            ]);
          }
          setinnerload(false);
        }
      });
    }, getTypeWatchDelay(searchString, 2000));
  }

  function showSchoolData(eOrObj) {
    let id, name, contactid, schoolTimeZone, defaultTicketStatus;

    setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: 'd-none' });

    id = eOrObj?.school_id
    name = eOrObj?.school_name
    contactid = eOrObj?.oldest_user_id || null
    schoolTimeZone = eOrObj?.timezone_data?.timezone || null
    defaultTicketStatus = eOrObj?.default_ticket_status == 1 ? 1 : 0

    reduxDispatch(setAdminSchoolId(id));
    reduxDispatch(setSchoolContactID(contactid));
    reduxDispatch(setSchoolname(name));
    reduxDispatch(setSelectedSchoolTimeZone(schoolTimeZone));
    reduxDispatch(setDefaultTicketStatus(defaultTicketStatus));
    setSchoolData({ ...SchoolData, Schoolname: name, SchoolID: id, schoolTimeZone: schoolTimeZone, defaultTicketStatus: defaultTicketStatus })
  }

  return (
    <>
      <div className="row align-items-center px-3">
        <div className="col-md-12 px-0">
          <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
            <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search searchIconClass"></i></div>
            <input className="form-control" autoComplete="off" type="text" placeholder={`Search by Serial, Asset Tag, Ticket #`} style={{ backgroundColor: '#f9fafb' }}
              value={SearchForSchoolName} onChange={(e) => { setSearchForSchoolName(e.target.value) }}
              onKeyUp={(e) => showSchoolName(e.target.value)}
              onPaste={(e) => { onPasteRestriction(e); showSchoolName(e.target.value) }}
              onKeyDown={(e) => { onKeyDownRestrict(e); showSchoolName(e.target.value) }}
            />
            <div className={`SuggestionBoxDiv ${SchoolSuggestiobBox.ShowSuggestion}`} style={{ zIndex: '1' }} ref={suggestionBoxRef}>
              {innerload && (
                <div className='row'>
                  <div className="col-12 text-center pt-2">
                    <img src="images/loder.svg" className="" style={{ width: "30px" }} />
                  </div>
                </div>
              )}

              {SuggestionBoxArray}
            </div>
          </form>
        </div>
      </div >

      <AlertPopup isshow={WarningPopup} img={'/images/greenInfo.svg'}
        headingtext={''} text={`You have just selected a ${organization} that does not belong to the location you are assigned to. Double check the ${organization} name and verify you selected the right account. Proceed?`}
        cancelcall={(e) => setWarningPopup(false)}
        canceltext={"No"} successtext={"Yes"} successcall={() => {
          setWarningPopup(false);
          if (PendingSchoolSelection) {
            setSearchForSchoolName("");
            showSchoolData(PendingSchoolSelection);
            navigate("/school-tickets", {
              state: {
                search: PendingSchoolSelection?.ticket_num,
                status: PendingSchoolSelection?.grid_status,
              },
            });
            setPendingSchoolSelection(null);
          }
        }} btntype={'SaveBtn'} />
    </>
  )
}
